import { Injectable } from '@angular/core';
import { HttpClientWrapper } from '../../../../http-client-wrapper';

@Injectable({ providedIn: 'root' })
export class VehicleAnalyticsDataService {
  constructor(private httpClientWrapper: HttpClientWrapper) {}
}
